module.exports = __webpack_public_path__ + "static/images/styles/images/nations/ussr.0fb2f64e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/ussr.png
// module id = 3678
// module chunks = 11